"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _cache = require("../cache");
var _removeAdditionalParameterFromFiltersPickedFromUrl = _interopRequireWildcard(require("../removeAdditionalParameterFromFiltersPickedFromUrl"));
var _excluded = ["query"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var searchInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var context, searchFetcher, _context$query, query, filtersPickedFromUrl, page, urlContainsFilters, urlFilters, getFiltersFromUrl, filtersPickedFromUrlWithoutAdditionalParameters, pickedFilters, fullUrl, fetchedResult, _Object$keys, _context$cache, _context$cache$data$f, _context$cache$data, _context$cache$data$f2, foundKey, defaultFilters, result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context = _ref.context, searchFetcher = _ref.searchFetcher;
            _context$query = context.query, query = _context$query.query, filtersPickedFromUrl = (0, _objectWithoutProperties2["default"])(_context$query, _excluded);
            page = filtersPickedFromUrl !== null && filtersPickedFromUrl !== void 0 && filtersPickedFromUrl.p ? filtersPickedFromUrl.p : 1;
            if (filtersPickedFromUrl !== null && filtersPickedFromUrl !== void 0 && filtersPickedFromUrl.p) {
              delete filtersPickedFromUrl.p;
            }
            urlContainsFilters = context.asPath.includes("?");
            urlFilters = filtersPickedFromUrl;
            getFiltersFromUrl = function getFiltersFromUrl() {
              var dataPairArray = [];
              var url = context.asPath.split("?");
              var filters = url[1].split("&");
              filters.forEach(function (filter) {
                var dataPair = filter.split("=");
                if (dataPair[0] === "p") return;
                var dataArray = [];
                dataArray.push(dataPair[0]);
                dataArray.push(dataPair[1]);
                dataPairArray.push(dataArray);
              });
              return Object.fromEntries(dataPairArray);
            };
            if (Object.keys(urlFilters).length === 0 && urlContainsFilters) {
              urlFilters = getFiltersFromUrl();
            }
            filtersPickedFromUrlWithoutAdditionalParameters = (0, _removeAdditionalParameterFromFiltersPickedFromUrl["default"])(Object.keys(urlFilters));
            pickedFilters = filtersPickedFromUrlWithoutAdditionalParameters.reduce(function (acc, current) {
              if (current === "dir" || current === "p") {
                return acc;
              }
              if (current === "order") {
                var orderFilterWithParameterRemoved = (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(urlFilters[current]);
                acc["sort"] = {
                  id: "".concat(orderFilterWithParameterRemoved, "-").concat(urlFilters["dir"]),
                  value: "".concat(orderFilterWithParameterRemoved, "-").concat(urlFilters["dir"])
                };
                return acc;
              }
              var rangeFilters = ["diameter", "height", "width", "length", "final_price", "capacity"];
              if (rangeFilters.includes(current)) {
                var range = urlFilters[current].split("-");
                var toRangeWithParameterRemoved = (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(range[1]);
                acc[current] = {
                  from: current === "capacity" ? Number(range[0] * 1000) : Number(range[0]),
                  to: current === "capacity" ? Number(toRangeWithParameterRemoved * 1000) : Number(range[1])
                };
                return acc;
              }
              acc[current] = urlFilters[current].split(",").map(function (id) {
                return {
                  id: (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(id)
                };
              });
              return acc;
            }, {});
            fullUrl = decodeURIComponent(context.asPath);
            fetchedResult = (0, _cache.getResultFromCache)(fullUrl, context.cache);
            if (fetchedResult) {
              _context.next = 22;
              break;
            }
            foundKey = (_Object$keys = Object.keys((_context$cache = context.cache) === null || _context$cache === void 0 ? void 0 : _context$cache.data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (key) {
              return key.includes("catalogsearch/result");
            });
            defaultFilters = (_context$cache$data$f = (_context$cache$data = context.cache.data) === null || _context$cache$data === void 0 ? void 0 : (_context$cache$data$f2 = _context$cache$data[foundKey]) === null || _context$cache$data$f2 === void 0 ? void 0 : _context$cache$data$f2.defaultFilters) !== null && _context$cache$data$f !== void 0 ? _context$cache$data$f : null;
            _context.next = 17;
            return searchFetcher({
              phrase: encodeURIComponent(context.query.query),
              language: context.language,
              pickedFilters: pickedFilters,
              currentPage: page,
              pageSize: global.__appConfig__.categoryPageSizeLargerRange,
              initialFilters: defaultFilters
            });
          case 17:
            result = _context.sent;
            (0, _cache.setUrlInCache)((0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(fullUrl), result, context.cache);
            return _context.abrupt("return", {
              initialProductsAndFilters: result,
              initialQuery: context.query.query,
              initialPage: page,
              pickedFilters: pickedFilters,
              cache: context.cache
            });
          case 22:
            return _context.abrupt("return", {
              initialProductsAndFilters: fetchedResult,
              initialQuery: context.query.query,
              pickedFilters: pickedFilters,
              cache: context.cache
            });
          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function searchInitialProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = searchInitialProps;
exports["default"] = _default;